import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"

export default class extends Controller {
  static values = {
    open: { type: Boolean, default: false },
  }

  connect() {
    this.modal = new bootstrap.Modal(this.element)
  }

  open() {
    if (!this.modal.isOpened) {
      this.modal.show()
    }
  }

  close(event) {
    if (event.detail.success && !this.openValue) {
      this.modal.hide()
    }
  }

  clear(event) {
    if (event.detail.success) {
      event.target.reset();

      let inputFields = event.target.querySelectorAll('input, textarea, select');
      inputFields.forEach(field => field.classList.remove('is-invalid'));

      let errorMessages = event.target.querySelectorAll('.error-message');
      errorMessages.forEach(message => message.remove());

      let feedbackDivs = event.target.querySelectorAll('.invalid-feedback');
      feedbackDivs.forEach(div => div.remove());

      let errorMessagesDivs = event.target.querySelectorAll('.alert-danger');
      errorMessagesDivs.forEach(div => div.remove());
    }
  }

  hide() {
    this.modal.hide()
  }

  print(event) {
    event.preventDefault();
    const url = event.currentTarget.dataset.url;

    const iframe = document.createElement('iframe');
    iframe.style.position = 'fixed';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = 'none';
    iframe.src = url;

    document.body.appendChild(iframe);

    iframe.onload = function () {
      setTimeout(() => {
        iframe.contentWindow.print();
        document.body.removeChild(iframe);
      }, 500);
    };
  }
}